import SidebarMenu from '../routes/SidebarMenu';
import support from './Support';
import home from './HomePath';

const dynamicGroups = SidebarMenu();

const menuItems = {
  items: [home, ...dynamicGroups, support]
};

export default menuItems;
